module.exports = __webpack_public_path__ + "img/menu-avril.10d1c954.jpg";